/** @format */

import React, { Fragment, useEffect, useState, useRef } from "react";
import TableForm from "./tableForm";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import { ToastContainer } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";

import { Document, Page, pdfjs } from "react-pdf";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

import FormApp1 from "./formApp_1";
import FormApp2 from "./formApp_2";
import FormApp3 from "./formApp_3";
import FormApp4 from "./formApp_4";
import FormApp5 from "./formApp_5";
import FormApp6 from "./formApp_6";
import FormApp7 from "./formApp_7";
import FormApp8 from "./formApp_8";
import FormApp9 from "./formApp_9";
import FormApp10 from "./formApp_10";
import ApprovalBar from "./approvalBar";
import { CommentModal } from "./commentModal";
import CommentsList from "./commentsListDisplay";
import { set } from "date-fns";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

export const MyRequests = ({ setAuth }) => {
  const [name, setName] = useState("");
  const [empId, setEmpId] = useState(null);
  const [empLvl, setEmpLvl] = useState(null);
  const [empRole, setEmpRole] = useState(null);
  const [app1, setApp1] = useState(null);
  const [app2, setApp2] = useState(null);
  const [app3, setApp3] = useState(null);
  const [app4, setApp4] = useState(null);
  const [app5, setApp5] = useState(null);
  const [app6, setApp6] = useState(null);
  const [app7, setApp7] = useState(null);
  const [app8, setApp8] = useState(null);

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setEmpId(parsRes.emp_id);
      setEmpLvl(parsRes.emp_level);
      setEmpRole(parsRes.emp_role);
      setApp1(parsRes.approver_1);
      setApp2(parsRes.approver_2);
      setApp3(parsRes.approver_3);
      setApp4(parsRes.approver_4);
      setApp5(parsRes.approver_5);
      setApp6(parsRes.approver_6);
      setApp7(parsRes.approver_7);
      setApp8(parsRes.approver_8);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [requests, setRequests] = useState([]);
  // const [requestID, setRequestID] = useState(null)
  const [itemsTable, setItemsTable] = useState([]);

  const [approveRequestData, setApproveRequestData] = useState({
    reqIDRec: null,
    appIdRec: null,
    appTitleRec: null,
    declinedByRec: null,
    empIdRec: null,
    empNameRec: null,
    reqTimeRec: null,
    appTimeRec: null,
    comment: "",
  });

  const [declineRequestData, setDeclineRequestData] = useState({
    reqIDRec: null,
    appIdRec: null,
    declinedByRec: null,
    empIdRec: null,
    empNameRec: null,
    reqTimeRec: null,
    appTimeRec: null,
    comment: "",
  });

  const getRequests = async () => {
    setRequests([]);
    // Get all current requests by the user
    if (empId !== null && empId !== undefined && empId !== "") {
      const allRequests = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/myRequests/${empId}`
      );
      const parseRes = await allRequests.json();

      const sortedRequests = parseRes.sort((a, b) =>
        a.req_date > b.req_date ? 1 : -1
      );
      setRequests(sortedRequests);
      // setRequests(parseRes);
      // sort requests by the req_date column

      // console.log(sortedRequests);

      // console.log(parseRes);
    }
  };

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
  };

  const [requestCurrentStatus, setRequestCurrentStatus] = useState([]);

  const getRequestCurrentStatus = async (reqId) => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/requestCurrentStatus/` + reqId
    );
    const data = await response.json();
    if (response.ok) {
      setRequestCurrentStatus(data);
    }
  };

  const [currentUserAppState, setCurrentUserAppState] = useState(null);
  const getCurrentUserAppState = () => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].role_id === empRole) {
        setCurrentUserAppState(approvers[i].app_id);
      }
    }
  };

  const [approvalRecords, setApprovalRecords] = useState([]);
  const fetchApprovalRecords = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approval_records`
    );
    const data = await response.json();
    setApprovalRecords(data);
  };

  const [currentReqRecord, setCurrentReqRecord] = useState([]);
  const fetchCurrentReqRecord = async (reqID) => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approval_records/${reqID}`
    );
    const data = await response.json();
    if (response.status === 200) {
      setCurrentReqRecord(data);
    }
  };

  const [currentReqComments, setCurrentReqComments] = useState([]);

  const getCurrentReqComments = () => {
    let reqCommentsToDisplay = [];
    for (let i = 0; i < currentReqRecord.length; i++) {
      if (currentReqRecord[i].action_comment !== "") {
        const title =
          currentReqRecord[i].app_title || currentReqRecord[i].declined_by;
        const comment = currentReqRecord[i].action_comment;

        reqCommentsToDisplay.push({ title, comment }); // Store as key-value pairs
      }
    }
    setCurrentReqComments(reqCommentsToDisplay);
  };

  const [currentApproverTitle, setCurrentApproverTitle] = useState(null);
  const getCurrentApproverTitle = () => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].role_id === empRole) {
        setCurrentApproverTitle(approvers[i].app_title);
      }
    }
  };

  const [filteredDocs, setFilteredDocs] = useState([]);
  const filterDocs = () => {
    if (docs.length !== 0) {
      const filtered = docs.filter((doc) =>
        [
          "approver_1",
          "approver_2",
          "approver_3",
          "approver_4",
          "approver_5",
          "approver_6",
          "approver_7",
          "approver_8",
        ].some((approver) => doc[approver] === currentUserAppState)
      );

      setFilteredDocs(filtered);
    }
  };
  const [displayedRequests, setDisplayedRequests] = useState([]);

  const filterRequests = () => {
    setDisplayedRequests(requests);
  };
  // const [requestData, setRequestData] = useState([]);
  // const [itemsTableData, setItemsTableData] = useState([]);
  const [selectedReqID, setSelectedReqID] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const [previouslySelectedId, setPreviouslySelectedId] = useState(null);

  const handleRequestSelect = (reqID, docTypeID) => {
    setPreviouslySelectedId(selectedReqID);
    setSelectedReqID(reqID);
    setSelectedForm(docTypeID);

    setIsClicked(false);
  };
  const [appReqStatus, setAppReqStatus] = useState({
    req_id: null,
    approver: "",
    declined: false,
  });

  const [decReqStatus, setDecReqStatus] = useState({
    req_id: null,
    approver: "",
    declined: true,
  });

  const [decRecApprover, setDecRecApprover] = useState(null);
  const [appRecApprover, setAppRecApprover] = useState(null);

  useEffect(() => {
    setDecReqStatus({ ...decReqStatus, approver: decRecApprover });
  }, [decRecApprover]);

  useEffect(() => {
    setAppReqStatus({ ...appReqStatus, approver: appRecApprover });
  }, [appRecApprover]);

  // const updateReqAppStatus = () => {
  //   if (filteredDocs.length > 0) {
  //     const currDoc = filteredDocs.filter(
  //       (filter) => filter.doc_type_id === selectedForm
  //     );
  //     const currDocArray = Object.entries(currDoc[0]);
  //     let returned = null;

  //     for (let i = 0; i < currDocArray.length; i++) {
  //       const key = currDocArray[i][0];
  //       const value = currDocArray[i][1];

  //       if (value === currentUserAppState) {
  //         returned = value;

  //         setAppRecApprover(key);

  //         setDecRecApprover(key);
  //         // setDecReqStatus({
  //         //   ...decReqStatus,
  //         //   approver: key,
  //         // });
  //       }
  //     }
  //   }
  // };

  const [selectedReqData, setSelectedReqData] = useState([]);
  const [filesPaths, setFilePaths] = useState([]);

  async function getSelectedReqData(selectedReqId) {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/requests/` + selectedReqId
    );
    const data = await response.json();
    setFilePaths(data.filePaths);
    if (response.ok) {
      setSelectedReqData(data);
    }
  }

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    if (selectedReqID !== previouslySelectedId && selectedReqID !== null) {
      getSelectedReqData(selectedReqID);
    }
    if (selectedReqID !== null) {
      fetchCurrentReqRecord(selectedReqID);
      getRequestCurrentStatus(selectedReqID);
    }
  }, [selectedReqID]);

  useEffect(() => {
    getCurrentReqComments();
  }, [currentReqRecord]);

  const displayApproverTitle = (appId) => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_id == appId) {
        return approvers[i].app_title;
      }
    }
  };

  const [approversTitlesList, setApproversTitlesList] = useState([]);

  const getTitlesList = () => {
    let titlesList = [];
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].doc_type_id === selectedReqData.requestData.doc_type) {
        titlesList.push(
          displayApproverTitle(selectedReqData.requestData.appro_1),
          displayApproverTitle(selectedReqData.requestData.appro_2),
          displayApproverTitle(selectedReqData.requestData.appro_3),
          displayApproverTitle(selectedReqData.requestData.appro_4),
          displayApproverTitle(selectedReqData.requestData.appro_5),
          displayApproverTitle(selectedReqData.requestData.appro_6),
          displayApproverTitle(selectedReqData.requestData.appro_7),
          displayApproverTitle(selectedReqData.requestData.appro_8)
        );
      }
    }
    setApproversTitlesList(titlesList.filter((titles) => titles != null));
    // return titlesList.filter((titles) => titles != null);
  };

  useEffect(() => {
    getTitlesList();
  }, [selectedReqData]);

  useEffect(() => {
    getName();
    fetchApprovalRecords();
  }, []);

  // useEffect(() => {
  //   updateReqAppStatus();
  // }, [selectedForm]);

  useEffect(() => {
    setAppReqStatus({ ...appReqStatus, req_id: selectedReqID });
    setDecReqStatus({ ...decReqStatus, req_id: selectedReqID });
  }, [selectedReqID]);

  useEffect(() => {
    fetchAppro();
  }, [name]);

  useEffect(() => {
    fetchDocs();
    getCurrentApproverTitle();
  }, [approvers]);

  useEffect(() => {
    getRequests();
  }, [empId]);

  useEffect(() => {
    getCurrentUserAppState();
    filterRequests();
  }, [requests]);

  useEffect(() => {
    filterDocs();
  }, [currentUserAppState]);

  useEffect(() => {
    filterRequests();
  }, [filteredDocs]);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast.current.show({
      severity: "success",
      summary: "Session",
      detail: "Deconnecté",
    });
  };

  const [requestDate, setRequestDate] = useState(null);
  const getRequestDate = () => {
    for (let i = 0; i < displayedRequests.length; i++) {
      if (displayedRequests[i].req_id == selectedReqID) {
        setRequestDate(displayedRequests[i].req_date);
      }
    }
  };

  const [isCommentExpanded, setIsCommentExpanded] = useState(false);

  const toggleCommentSection = () => {
    setIsCommentExpanded(!isCommentExpanded);
  };

  useEffect(() => {
    getRequestDate();
  }, [selectedReqID]);

  useEffect(() => {
    setApproveRequestData({ ...approveRequestData, reqIDRec: selectedReqID });
    setDeclineRequestData({ ...declineRequestData, reqIDRec: selectedReqID });
  }, [selectedReqID]);

  useEffect(() => {
    setApproveRequestData({
      ...approveRequestData,
      appIdRec: currentUserAppState,
    });
    setDeclineRequestData({
      ...declineRequestData,
      appIdRec: currentUserAppState,
    });
  }, [currentUserAppState]);

  const [currentDate, setCurrentDate] = useState(new Date());
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setApproveRequestData({
      ...approveRequestData,
      appTimeRec: currentDate,
      empIdRec: empId,
      empNameRec: name,
      reqTimeRec: requestDate,
      appTitleRec: currentApproverTitle,
    });
    setDeclineRequestData({
      ...declineRequestData,
      appTimeRec: currentDate,
      empIdRec: empId,
      empNameRec: name,
      reqTimeRec: requestDate,
      declinedByRec: currentApproverTitle,
    });
  }, [currentDate]);

  const [approveEvent, setApproveEvent] = useState(false);

  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [declineStatus, setDeclineStatus] = useState(false);
  const [commentContent, setCommentContent] = useState("");

  const handleCommentSave = () => {
    setApproveRequestData({ ...approveRequestData, comment: commentContent });
    setDeclineRequestData({ ...declineRequestData, comment: commentContent });
  };

  useEffect(() => {
    handleCommentSave();
  }, [commentContent]);

  const handleApproveButton = async (e) => {
    // e.preventDefault();

    // Make a fetch() request to submit the form data to the backend.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approve`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(approveRequestData),
      }
    );

    const reqAppUpdate = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/updateRequest`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(appReqStatus),
      }
    );

    // Check the response status code.
    if (response.status === 200 && reqAppUpdate.status === 200) {
      // Success!
      setApproveEvent(!approveEvent);
      getSelectedReqData(selectedReqID);
      document.getElementById("btn-submit-form").disabled = true;
      setIsClicked(!isClicked);
      fetchCurrentReqRecord(selectedReqID);

      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande Approuvée",
      });
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  const handleDeclineButton = async (e) => {
    // e.preventDefault();

    // Make a fetch() request to submit the form data to the backend.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/decline`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(declineRequestData),
      }
    );

    const reqAppUpdate = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/updateRequest`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(decReqStatus),
      }
    );

    // Check the response status code.
    if (response.status === 200 && reqAppUpdate.status === 200) {
      // Success!
      setApproveEvent(!approveEvent);
      getSelectedReqData(selectedReqID);
      document.getElementById("btn-submit-form").disabled = true;
      setIsClicked(!isClicked);

      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande Approuvée",
      });
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  // const reqAppUpdate = await fetch("http:${process.env.REACT_APP_BACKEND_URL}/updateRequest", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         token: localStorage.token,
  //       },
  //       body: JSON.stringify(appReqStatus),
  //     });

  // confirmation dialog -------------------------------------------

  const handleMyRequestDelete = async () => {
    try {
      setDisplayedRequests([]);
      if (
        selectedReqID !== "" ||
        selectedReqID !== null ||
        selectedReqID !== undefined
      ) {
        const userDelete = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/myRequestDelete/${selectedReqID}`,
          {
            method: "DELETE",
            headers: { token: localStorage.token },
          }
        );
        if (userDelete.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "conifrmé",
            detail: "Demande Annulée",
            life: 3000,
          });

          getRequests();
        }
      }
      // const parsRes = await userDelete.json();
    } catch (err) {
      console.error(err.message);
    }
  };

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "demande envoyée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "Action annulée",
      life: 3000,
    });
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Confirmer l'approbation de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleApproveButton(),
      reject,
    });
  };

  const confirm3 = () => {
    confirmDialog({
      message: "Confirmer l'annulation de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleMyRequestDelete(),
      reject,
    });
  };

  // ------------------------------------------------------------
  const approversList = approversTitlesList;
  let approvals = {};

  approversList.forEach((approver, index) => {
    const approvalStatus =
      selectedReqData.requestData[`req_approver_${index + 1}`];
    approvals[approver] = approvalStatus;
  });

  const [declinersIDs, setDeclinersIDs] = useState([]);

  const getApprovalRecStatus = () => {
    if (currentReqRecord.length > 0) {
      let declinersIDs = [];
      for (let i = 0; i < currentReqRecord.length; i++) {
        const item = currentReqRecord[i];
        const declined_by = item.declined_by;
        const app_title = item.app_title;
        const date_time = item.op_time; // Assuming date_time is a Date object

        // Find all entries that have the same declined_by and app_title
        const matchingEntries = declinersIDs.filter(
          (d) => d.declined_by === declined_by && d.app_title === app_title
        );

        if (matchingEntries.length > 0) {
          // Keep only the last matching entry
          declinersIDs = declinersIDs.filter(
            (d) => !(d.declined_by === declined_by && d.app_title === app_title)
          );

          declinersIDs.push(matchingEntries[matchingEntries.length - 1]);
        } else if (declined_by !== null && declined_by !== undefined) {
          // Include if no match and 'declined_by' exists
          declinersIDs.push({ declined_by, app_title, date_time });
        }
      }
      if (declinersIDs.length > 0) {
        setDeclinersIDs(declinersIDs[0].declined_by);
      }
    }
  };

  useEffect(() => {
    getApprovalRecStatus();
  }, [currentReqRecord]);

  // print the document -------------------------------------------------

  const componentRef = React.useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return <button>Imprimer</button>;
  }, []);

  //---------------------------------------------------------------------------------
  const [selectedRowId, setSelectedRowId] = useState(null);

  // ... more comments

  const showSideBar = () => {
    const sideBar = document.querySelector(".requests-display-side");
    sideBar.style.display = "flex";
  };

  const hideSideBar = () => {
    const sideBar = document.querySelector(".requests-display-side");
    sideBar.style.display = "none";
  };

  // console.log(displayedRequests);

  return (
    <Fragment>
      {/* <div className='header m-0 bg-primary text-white text-center'>
        <h1>My First Bootstrap Page</h1>
        <p>Resize this responsive page to see the effect!</p>
      </div> */}
      <div className="main-page-container">
        <div id="navbar" className="topnav">
          <div onClick={showSideBar} className="menu-icon-container ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
              className="my-svg"
            >
              <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
            </svg>
          </div>

          <div className="left-menu-4">
            <Link to="/dashboard">Accueil</Link>
          </div>
          <div className="right-menu">
            <button className="dash-logout" onClick={(e) => logout(e)}>
              Se déconnecter
            </button>

            <div className=" relative flex items-center justify-center float-right pr-3">
              <span className="p-3 text-white">{name}</span>
            </div>
          </div>
        </div>

        <div className="dash-body">
          <div className="dash-body-lower">
            <div className="approval-progress-bar">
              <div className="approval-bar">
                {/* create a bar divided by the number of approvers, each approver is within a rectangle. once an approver approves the document, its rectangle color changes to green  */}
                <ApprovalBar
                  className="app-bar-component"
                  approvers={approversList}
                  requestCurrentStatus={requestCurrentStatus}
                />
              </div>
            </div>
            <div className="request-approve-container">
              <div className="requests-display">
                <table className="">
                  <thead className="	">
                    <tr>
                      <th>Titre</th>

                      <th>Date de la demande</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedRequests.map((request) => (
                      <tr
                        className={`table-row ${request.req_id === selectedRowId ? "selected" : ""
                          }`}
                        onClick={(e) => {
                          setSelectedRowId(request.req_id);
                          handleRequestSelect(request.req_id, request.doc_type);
                        }}
                        key={request.req_id}
                      >
                        <td>{request.doc_tittle}</td>
                        <td>
                          {new Date(request.req_date).toLocaleDateString(
                            "en-GB"
                          )}
                          <br />
                          {new Date(request.req_date).toLocaleTimeString(
                            "en-GB"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="requests-display-side">
                <div className="left-menu-2">
                  <Link to="/dashboard">Home</Link>
                </div>
                <div
                  onClick={hideSideBar}
                  className="menu-close-icon-container-2 "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                    className=""
                  >
                    <path
                      fill="#03274B"
                      d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                    />
                  </svg>
                </div>
                <table className="requests-display-side-table">
                  <thead className="	">
                    <tr>
                      <th>Titre</th>

                      <th>Date de la demande</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedRequests.map((request) => (
                      <tr
                        className={`table-row ${request.req_id === selectedRowId ? "selected" : ""
                          }`}
                        onClick={(e) => {
                          setSelectedRowId(request.req_id);
                          handleRequestSelect(request.req_id, request.doc_type);
                        }}
                        key={request.req_id}
                      >
                        <td>{request.doc_tittle}</td>
                        <td>
                          {new Date(request.req_date).toLocaleDateString(
                            "en-GB"
                          )}
                          <br />
                          {new Date(request.req_date).toLocaleTimeString(
                            "en-GB"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {selectedForm && (
                <div id="documentDisplay" className="document">
                  {selectedForm === 1 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp1
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 2 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp2
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 3 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp3
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 4 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp4
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 5 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp5
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 6 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp6
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 7 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp7
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 8 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp8
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 9 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp9
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}
                  {selectedForm === 10 && (
                    <div className="docPrintContainer" ref={componentRef}>
                      <FormApp10
                        reqID={selectedReqID}
                        empId={empId}
                        approveEvent={approveEvent}
                      />
                    </div>
                  )}

                  {/* ... */}
                </div>
              )}

              {/* <button className='req-approve-btn' onClick={handleApproveButton}>
            Approuver
          </button> */}

              <div className="doc-approve-confirm">
                <Toast ref={toast} />

                <div className="p-confirm-dialog	">
                  <ConfirmDialog className="p-confirm-dialog" />
                </div>

                {/* confirmation dialog ----------------------------------------- */}
                <Toast ref={toast} />
              </div>
            </div>
          </div>

          <div className="navBarControls">
            <div className="control-buttons">
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle="AwesomeFileName"
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />
              {/* <Button
                id="btn-delete-app-req"
                onClick={confirm3}
                icon="pi pi-times"
                label="Annuler la demande!"
                className="bg-orange-500 hover:bg-red-500 disabled:ml-auto disabled:mr-auto  font-bold py-2 px-4 rounded"
              ></Button> */}
            </div>

            <div className="comments-section-container">
              <span>Liste des commentaires</span>
              <CommentsList comments={currentReqComments} />
            </div>

            {/* <CommentModal /> */}

            <div className="aprenticeship-req-linked-files">
              <span>Documents en pièces jointes</span>
              {filesPaths.map((f, i, id) => (
                <li
                  style={{ listStyleType: "none" }}
                  className="apShip-req-fileItem-list"
                >
                  {f.endsWith(".jpeg") ||
                    f.endsWith(".jpg") ||
                    f.endsWith(".png") ||
                    f.endsWith(".svg") ? (
                    // Image file
                    <a
                      href={`${process.env.REACT_APP_BACKEND_URL}` + f}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        id={id}
                        style={{ maxWidth: "200px", maxHeight: "auto" }}
                        src={`${process.env.REACT_APP_BACKEND_URL}` + f}
                        alt={f}
                      />
                    </a>
                  ) : f.endsWith(".pdf") ? (
                    <a
                      href={`${process.env.REACT_APP_BACKEND_URL}` + f}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <iframe
                        id="iframe"
                        style={{ maxWidth: "200px", maxHeight: "auto" }}
                        src={`${process.env.REACT_APP_BACKEND_URL}` + f}
                      ></iframe>
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      ></div>
                    </a>
                  ) : (
                    // Other file type
                    <div>Unsupported file type</div>
                  )}
                </li>
              ))}
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </Fragment>
  );
};
